import { dynamicOptions, inject } from 'aurelia-framework';

@dynamicOptions
@inject(Element)
class OacClassCustomAttribute {
  constructor(element) {
    this._element = element;
  }
  propertyChanged(name, newValue) {
    const hasIt = [...this._element.classList].includes(name);
    if (newValue && !hasIt) {
      this._element.classList.add(name);
    } else if (!newValue && hasIt) {
      this._element.classList.remove(name);
    }
  }
}

export { OacClassCustomAttribute };
